<template>
  <div :style="backgroundStyle">
    <div
      :style="barStyle"
      class="_bar"
    />
  </div>
</template>
<script>
export default {
  name: 'CProgressBar',
  props: {
    progress: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    backgroundStyle() {
      return {
        background: this.$colors.grey.lighten3,
        height: '6px',
        width: '100%',
        borderRadius: '3px',
        overflow: 'hidden',
      };
    },
    barStyle() {
      return {
        background: this.$colors.grey.darken3,
        height: '6px',
        width: `${this.progress}%`,
        borderBottomLeftRadius: '3px',
        borderTopLeftRadius: '3px',
      };
    },
  },
};
</script>
<style scoped type="text/scss">
._bar {
    transition: width .3s ease-in-out;
}
</style>
